import React from "react";
import { ScrollView, View } from "react-native";
import { SGradient, SHr, SIcon, SImage, SNavigation, SPage, SStorage, SText, STheme, SView } from "servisofts-component";
import Page from "./Page";
// import SIcon from "../../Assets/SIcon";
import { Route } from "@react-navigation/native";
// eslint-disable-next-line
import SSocket from "servisofts-socket";
import Model from "../../Model";
// import CajaActiva from "./components/CajaActiva";
// import PopupEditarTema from "../../Pages/empresa/Components/PopupEditarTema";
// import BackgroundImage from "../BackgroundImage";
// import MDL from "../../MDL";
// import MenuEmpresa from "../../Components/empresa/menu_lista"


export default class Barra extends React.Component {
    state = {
        open: false,
        openWidth: 200,
        closeWidth: 40,
    }

    componentDidMount(): void {
        SStorage.getItem("menu_global_open", (value) => {
            this.setState({
                open: value === "1"
            })
        })
    }

    changeStatus() {

        if (this.state.open) {
            this.close()
        } else {
            this.open();
        }
    }
    open() {
        SStorage.setItem("menu_global_open", "1");

        this.setState({
            open: true,
        })
    }
    close() {
        SStorage.setItem("menu_global_open", "0");
        this.setState({
            open: false,
        })
    }
    render() {
        console.log("eee", this.state.closeWidth)
        console.log("aae", this.state.openWidth)
        const key_usuario = Model.usuario.Action.getKey();

        const permisos = {
            ver: "ver"
        }
        return <View style={{
            width: this.state.open ? this.state.openWidth : this.state.closeWidth,
            backgroundColor: STheme.color.background,
            borderRightWidth: 1,
            borderColor: STheme.color.card
        }}>
            {/* <BackgroundImage /> */}
            <SView row>
                <SView width={this.state.closeWidth} height={this.state.closeWidth} onPress={() => {
                    this.changeStatus()
                }} padding={4}>
                    <SIcon name="Menu" fill={STheme.color.text} />

                </SView>
            </SView>
            <SView col={"xs-12"} flex>
                <ScrollView showsVerticalScrollIndicator={false} >
                    <Page label={"Home"} url={"/"} icon={<SImage src={require("../../Assets/img/menu/iconHome.png")} />} />
                    <Page label={"Direccion General"} icon={<SImage src={require("../../Assets/img/menu/iconGeneral.png")} />}>
                        <Page label={"Usuarios"} url={"UsuarioPage"} permiso={permisos.ver} icon={<ImagePage key_page="d193a1b4-ccea-401a-856e-df7436010082" />} />
                        <Page
                            label={"DashBoard"}
                            url={"db"}
                            icon={<ImagePage key_page="3220cd37-2f24-44c8-939d-99b0f72895da" />}
                            permiso={permisos.ver}
                        />
                        <Page label={"Sucursales"} url={"SucursalPage"} icon={<ImagePage key_page="17c5fa4a-c1eb-428c-bb6f-1960417b04fa" />}
                            permiso={permisos.ver} />
                        <Page label={"Roles"} url={"/rol"}
                            permiso={permisos.ver} icon={<ImagePage key_page="e68c15ea-8396-40d5-b468-abf3902c659f" />} />
                        <Page label={"Grupos de ventas"} url={"/grupo_ventas"}
                            permiso={permisos.ver} icon={<ImagePage key_page="f7f1d0f1-1752-4bf5-9ced-814936d49d22" />} />
                        <Page label={"Responsabilidad"} url={"/responsabilidades"}
                            permiso={permisos.ver} icon={<ImagePage key_page="cb94e548-f4f8-43fb-9cf7-3a862a4c0869" />} />
                        {/* <Page label={"Resumen anual de activos"} url={"SucursalPage"} /> */}
                    </Page>
                    <Page label={"Finanzas y contabilidad"} icon={<SImage src={require("../../Assets/img/menu/iconFinConta.png")} />}>
                        <Page label={"Contabilidad"} url={"/contabilidad"}
                            permiso={permisos.ver} icon={<ImagePage key_page="c04367b7-a72b-4386-ae77-33348cb79436" />} />
                        <Page label={"Facturacion"} url={"/facturacion"}
                            permiso={permisos.ver} icon={<ImagePage key_page="0fd8098b-251c-49a8-8373-961d37e2df1d" />} />
                        <Page label={"Banco"} url={"BancoPage"}
                            permiso={permisos.ver} icon={<ImagePage key_page="c47c41e3-252c-40d1-8d92-117bd014bf1b" />} />
                        <Page label={"Inversiones"} url={"inversiones"}
                            permiso={permisos.ver} icon={<ImagePage key_page="cb2ee7ba-2c2c-4b13-b98c-c38f5e3285d2" />} />
                    </Page>
                    <Page label={"Ventas y Clientes"} icon={<SImage src={require("../../Assets/img/menu/iconVentasCli.png")} />}>
                        <Page label={"Caja"} url={"CajaPage"}
                            permiso={permisos.ver} icon={<ImagePage key_page="9837d1bd-986e-4b70-b3df-25e279ceec9e" />} />
                        <Page label={"Activos"} url={"/activos"}
                            permiso={permisos.ver} icon={<ImagePage key_page="d0d8348c-41a7-4ac2-9418-8460be8d8b97" />} />
                        <Page label={"Ventas"} url={"VentasPage"}
                            permiso={permisos.ver} icon={<ImagePage key_page="1fdec746-5a0c-4786-9d8d-44f46ab86a01" />} />
                        {/* <Page label={"Inversiones"} url={"inversiones"} /> */}
                    </Page>
                    <Page label={"Recursos Humanos"} icon={<SImage src={require("../../Assets/img/menu/iconRecurHum.png")} />}>
                        <Page label={"Entrenadores"} url={"EntrenadorPage"} permiso={permisos.ver} icon={<ImagePage key_page="3cf05e43-7cf5-40a9-a09a-60dd2be72d72" />} />
                        <Page label={"Toma de asistencia"} url={"EntrenamientoPage"} permiso={permisos.ver} icon={<ImagePage key_page="fb594a3b-6acd-488f-aa79-ec6a7a27e3b4" />} />
                        {/* <Page label={"Inversiones"} url={"inversiones"} /> */}
                    </Page>
                    <Page label={"Marketing y Ventas"} icon={<SImage src={require("../../Assets/img/menu/iconMarkVentas.png")} />}>
                        <Page label={"Calendario mensual clientes"} url={"/fidelizacion/calendario"} permiso={permisos.ver} icon={<ImagePage key_page="8fb22bfe-b7d4-423a-b81f-47c5bda4fafb" />} />
                        <Page label={"Inactivos"} url={"/fidelizacion/inactivos"} permiso={permisos.ver} icon={<ImagePage key_page="8fe3130f-dd82-4e79-b293-88950f1631f8" />} />
                        <Page label={"Comparativos"} url={"/fidelizacion/comparativos"} permiso={permisos.ver} icon={<ImagePage key_page="b2077bfb-4feb-4d0c-b97b-81e2b2ab3868" />} />
                        <Page label={"Fidelizacion"} url={"/fidelizacion"} permiso={permisos.ver} icon={<ImagePage key_page="3ab0c99a-0559-41cd-a2ac-5d828f209b39" />} />
                        <Page label={"Nuevos Inscritos"} url={"/fidelizacion/nuevos"} permiso={permisos.ver} icon={<ImagePage key_page="d1e7fc59-831a-453d-8d85-bd97f45e5ecf" />} />
                        <Page label={"Historial"} url={"/fidelizacion/historial"} permiso={permisos.ver} icon={<ImagePage key_page="ab8a05c6-829f-4591-8857-84f28acb62d9" />} />
                        <Page label={"Activos"} url={"/activos"} permiso={permisos.ver} icon={<ImagePage key_page="d0d8348c-41a7-4ac2-9418-8460be8d8b97" />} />
                        <Page label={"Ventas"} url={"VentasPage"} permiso={permisos.ver} icon={<ImagePage key_page="1fdec746-5a0c-4786-9d8d-44f46ab86a01" />} />

                        <Page label={"Paquetes"} url={"PaquetePage"} permiso={permisos.ver} icon={<ImagePage key_page="df48f3aa-aff7-46aa-95aa-91c689653ca6" />} />
                        <Page label={"Marketing"} url={"/marketing"} permiso={permisos.ver} icon={<ImagePage key_page="2facd725-ee32-417f-82b5-5fa093b3cd03" />} />
                        <Page label={"Red Social"} url={"client"} permiso={permisos.ver} icon={<ImagePage key_page="bb42252a-0d6d-4ecf-921d-c3ca5cc03f8c" />} />
                        {/* <Page label={"Inversiones"} url={"inversiones"} /> */}
                    </Page>
                    <Page label={"Atencion al cliente"} icon={<SImage src={require("../../Assets/img/menu/iconAtencion.png")} />}>
                        <Page label={"Atc"} url={"VendedorPage"} permiso={permisos.ver} icon={<ImagePage key_page="b818210a-9e59-41f3-9fc8-08a047f8e3ca" />} />
                        <Page label={"Cumpleanos"} url={"/fidelizacion/cumpleaños"} permiso={permisos.ver} icon={<ImagePage key_page="5a972556-7881-4cad-b28e-570ede34c8c1" />} />
                        <Page label={"dashboard asistencias"} url={"dashboard_asistencia"} permiso={permisos.ver} icon={<ImagePage key_page="08fcb160-4c0a-410e-9c67-ebe37412e577" />} />

                    </Page>
                    <Page label={"Operaciones logisticas"} icon={<SImage src={require("../../Assets/img/menu/iconOperaciones.png")} />}>
                        <Page label={"Servicios"} url={"ServiciosPage"} permiso={permisos.ver} icon={<ImagePage key_page="eb1f014d-cdc2-4086-a017-5b1ae4957dca" />} />
                        <Page label={"Servicios2"} url={"/servicio2"} permiso={permisos.ver} icon={<ImagePage key_page="449ee144-14b1-4731-b2dc-f0215fa96261" />} />
                        <Page label={"Molinetes"} url={"dispositivo"} permiso={permisos.ver} icon={<ImagePage key_page="44be3de7-aa27-4407-bcf7-2be5af79eeab" />} />
                        <Page label={"Entramientos historial"} url={"entrenamientos_historial"} permiso={permisos.ver} icon={<ImagePage key_page="e56d77d9-eccf-45a2-9e4b-29fd66aee9e6" />} />

                        {/* <Page label={"Inversiones"} url={"inversiones"} /> */}
                    </Page>
                    <Page label={"Menu Antiguo"} url={"/menu"} icon={<SImage src={require("../../Assets/img/menu/iconBack.png")} />}/>
                    {/* <Page label={"Menu"} url={"/menu"} icon={<SIcon name="Menu" fill={STheme.color.text} />} /> */}



                    {/* <Page label={"Iconos"} url={"/icons"} /> */}
                    <SHr h={100} />
                </ScrollView>

                <SView col={"xs-12"} pointerEvents="none" >
                    <SView style={{
                        top: -100,
                        width: "100%",
                        height: 100,
                        position: "absolute",

                    }} pointerEvents="none" >
                        <SGradient colors={[STheme.color.background + "ff", STheme.color.background + "00"]} />
                    </SView>
                </SView>
                <SView col={"xs-12"}  >
                    <SHr h={1} color={STheme.color.card} />
                    <Page label={"Mi Perfil"} url={"perfil"} icon={<SImage src={SSocket.api.root + "usuario/" + key_usuario} />} />
                    <Page label={"Ajustes"} url={"AjustesPage"} icon={<ImagePage key_page="80e7f2e9-af43-4826-a2e5-082d5e55a5ea" />} />

                    {/* <Page label={"Usuarios y Privacidad"}
                    // icon={<ImagePage key_page="419dfc13-34db-4935-a13c-b05cfd9d599a" />}
                    >
                        <Page label={"Roles y Permisos"} url={"/rol"} permiso="ver" />
                    </Page> */}
                    {/* <Page label={"Roles y Permisos"} url={"/rol"}
                        permiso="ver"
                        icon={<ImagePage key_page="c4666514-202f-4d8d-8656-64c82065ba67" />}
                    /> */}

                    <Page label={"Ayuda"} url={"/manual"}
                        icon={<ImagePage key_page="bf38c052-b726-43db-a66d-c202ef79a391" />}
                    />
                    <SHr />
                </SView>
            </SView>
        </View>
    }
}

const ImagePage = ({ key_page }: { key_page: string }) => {
    // @ts-ignore
    const urlrp = SSocket.api.roles_permisos;
    return <SImage src={urlrp + "page/" + key_page} />
}
const ImageLocal = ({ icon_page }: { icon_page: string }) => {
    // @ts-ignore
    const urlrp = "../../Assets/img/";
    return <SImage src={require(urlrp + "menu/" + icon_page)+".png"} />
}